<section class="consolidated-due-date">
  <div class="consolidated-due-date__header">
    <div class="header-main">
      <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    </div>
  </div>

  <div class="consolidated-due-date__filters ignore-export">
    <app-card-info>
      <div class="filters-container">
        <div class="filter-item filter-item--company" *ngIf="!isCompanyIdUser">
          <label class="filter-label">Empresa</label>
          <app-select
            [options]="companiesOptions"
            [allowEmptyPlaceholderSelect]="true"
            [(ngModel)]="selectedCompanyId"
            (ngModelChange)="handleFilterChange()"
            placeholder="Todas"
            class="company-select">
          </app-select>
        </div>

        <div class="filter-item">
          <label class="filter-label">Período</label>
          <app-select
            [options]="periodOptions"
            [(ngModel)]="selectedPeriod"
            (ngModelChange)="handlePeriodChange()"
            class="period-select">
          </app-select>
        </div>

        <div class="filter-item" *ngIf="selectedPeriod === 'custom'">
          <label class="filter-label">Data Início</label>
          <app-calendar [(ngModel)]="startDate" (sendCalendarValue)="handleFilterChange()">
          </app-calendar>
        </div>

        <div class="filter-item" *ngIf="selectedPeriod === 'custom'">
          <label class="filter-label">Data Fim</label>
          <app-calendar [(ngModel)]="endDate" (sendCalendarValue)="handleFilterChange()">
          </app-calendar>
        </div>

        <div class="filter-item actions ml-auto">
          <app-action-menu [items]="exportMenuItems" horientation="vertical"></app-action-menu>
        </div>
      </div>

      <div class="applied-period-info">
        <i class="pi pi-calendar-times"></i>
        <span>
          Exibindo vencimentos de
          <strong>{{ startDate | vaultDate }}</strong>
          até
          <strong>{{ endDate | vaultDate }}</strong>
        </span>
      </div>
    </app-card-info>
  </div>

  <div class="consolidated-due-date__content" *ngIf="data && !isLoading">
    <div class="metrics-grid" *ngIf="kpiGroups.length">
      <div
        class="metric-card"
        *ngFor="let kpi of kpiGroups"
        [class.metric-card--general]="kpi.isGeneral">
        <div class="metric-label">
          {{ kpi.label }}
          <i [class]="kpi.icon"></i>
        </div>

        <div class="metric-items" *ngIf="kpi.items.length">
          <div class="metric-item" *ngFor="let item of kpi.items">
            <span class="value">{{ item.value | vaultFormatCurrency: 2 }}</span>
            <span class="unit">
              {{ item.currency }}
              <span class="count-badge" *ngIf="item.count > 0">({{ item.count }})</span>
            </span>
          </div>
        </div>

        <div class="metric-total">
          <span class="total-label">{{ kpi.isGeneral ? 'Fluxo Total' : 'Total Previsto' }}</span>
          <div class="total-value-wrapper">
            <span class="value">{{ kpi.totalBRL | vaultFormatCurrency: 2 }}</span>
            <span class="unit">BRL</span>
          </div>
        </div>
      </div>
    </div>

    <div class="ptax-alert" *ngIf="data.ptaxDate">
      <app-simple-messages
        [text]="
          'Os valores previstos (BRL) são estimativas baseadas na PTAX de ' +
          (data.ptaxDate | vaultDate) +
          '.'
        "
        severity="info">
      </app-simple-messages>
    </div>

    <!-- Loans Table -->
    <div class="due-date-section" *ngIf="data.loans?.length">
      <app-table
        title="Empréstimos"
        icon="pi pi-wallet"
        [resizableColumns]="true"
        [reorderableColumns]="false"
        [items]="data.loans"
        [columnDefinitions]="loanColumns"
        [hasPagination]="false"
        [sortable]="true"
        (sendTableSort)="handleSort($event, 'loans')"
        theme="standard">
        <ng-template [appNamedTemplate]="'sequentialId'" let-item>
          <div class="id-cell-content">
            <i
              *ngIf="!item.hasHedge && item.currency !== 'BRL'"
              class="pi pi-exclamation-triangle warning-icon"
              pTooltip="Parcela sem derivativo contratado"
              tooltipPosition="top">
            </i>
            <span class="clickable-id ignore-export" (click)="openLoanDetails(item.id)">
              {{ item.sequentialId }}
            </span>
          </div>
          <span class="only-display-export">
            {{ item.sequentialId }}
          </span>
        </ng-template>

        <ng-template [appNamedTemplate]="'dueDate'" let-item>
          {{ item.dueDate | vaultDate }}
        </ng-template>

        <ng-template [appNamedTemplate]="'installmentAmount'" let-item>
          {{ item.currency }} {{ item.installmentAmount | vaultFormatCurrency: 2 }}
        </ng-template>

        <ng-template [appNamedTemplate]="'estimatedAmountBRL'" let-item>
          {{ item.estimatedAmountBRL | vaultFormatCurrency: 2 : 'BRL' }}
        </ng-template>

        <ng-template [appNamedTemplate]="'footer'" [isFooter]="true">
          <td *ngFor="let col of loanColumns" [ngStyle]="col.style">
            <div *ngIf="col.field === 'sequentialId'">
              <strong>Total</strong>
            </div>
            <div
              *ngIf="col.field === 'estimatedAmountBRL'"
              style="text-align: right; font-weight: bold; white-space: nowrap">
              {{ getLoansTotalEstimatedBRL() | vaultFormatCurrency: 2 : 'BRL' }}
            </div>
          </td>
        </ng-template>
      </app-table>
    </div>

    <!-- Derivatives Table -->
    <div class="due-date-section" *ngIf="data.derivatives?.length">
      <app-table
        title="Derivativos"
        icon="pi pi-chart-line"
        [resizableColumns]="true"
        [reorderableColumns]="false"
        [items]="data.derivatives"
        [columnDefinitions]="derivativeColumns"
        [hasPagination]="false"
        [sortable]="true"
        (sendTableSort)="handleSort($event, 'derivatives')"
        theme="standard">
        <ng-template [appNamedTemplate]="'dueDate'" let-item>
          {{ item.dueDate | vaultDate }}
        </ng-template>

        <ng-template [appNamedTemplate]="'notionalAmount'" let-item>
          {{ item.currency }} {{ item.notionalAmount | vaultFormatCurrency: 2 }}
        </ng-template>

        <ng-template [appNamedTemplate]="'netAmount'" let-item>
          {{ item.netAmount | vaultFormatCurrency: 2 : 'BRL' }}
        </ng-template>

        <ng-template [appNamedTemplate]="'incomeTax'" let-item>
          {{ item.incomeTax | vaultFormatCurrency: 2 : 'BRL' }}
        </ng-template>

        <ng-template [appNamedTemplate]="'footer'" [isFooter]="true">
          <td *ngFor="let col of derivativeColumns" [ngStyle]="col.style">
            <div *ngIf="col.field === 'sequentialId'">
              <strong>Total</strong>
            </div>
            <div
              *ngIf="col.field === 'netAmount'"
              style="text-align: right; font-weight: bold; white-space: nowrap">
              {{ getDerivativesTotalNetAmount() | vaultFormatCurrency: 2 : 'BRL' }}
            </div>
            <div
              *ngIf="col.field === 'incomeTax'"
              style="text-align: right; font-weight: bold; white-space: nowrap">
              {{ getDerivativesTotalIncomeTax() | vaultFormatCurrency: 2 : 'BRL' }}
            </div>
          </td>
        </ng-template>
      </app-table>
    </div>

    <!-- Comex Table -->
    <div class="due-date-section" *ngIf="data.comex?.length">
      <app-table
        title="Comex"
        icon="pi pi-globe"
        [resizableColumns]="true"
        [reorderableColumns]="false"
        [items]="data.comex"
        [columnDefinitions]="comexColumns"
        [hasPagination]="false"
        [sortable]="true"
        (sendTableSort)="handleSort($event, 'comex')"
        theme="standard">
        <ng-template [appNamedTemplate]="'sequentialId'" let-item>
          <span class="clickable-id ignore-export" (click)="openComexDetails(item.id)">
            {{ item.sequentialId }}
          </span>
          <span class="only-display-export">
            {{ item.sequentialId }}
          </span>
        </ng-template>

        <ng-template [appNamedTemplate]="'comexReference'" let-item>
          <span [title]="item.comexReference">{{ item.comexReference }}</span>
        </ng-template>

        <ng-template [appNamedTemplate]="'expirationDate'" let-item>
          {{ item.expirationDate | vaultDate }}
        </ng-template>

        <ng-template [appNamedTemplate]="'lcPaymentDate'" let-item>
          {{ item.lcPaymentDate ? (item.lcPaymentDate | vaultDate) : '-' }}
        </ng-template>

        <ng-template [appNamedTemplate]="'amount'" let-item>
          {{ item.currency }} {{ item.amount | vaultFormatCurrency: 2 }}
        </ng-template>

        <ng-template [appNamedTemplate]="'estimatedAmountBRL'" let-item>
          {{ item.estimatedAmountBRL | vaultFormatCurrency: 2 : 'BRL' }}
        </ng-template>

        <ng-template [appNamedTemplate]="'footer'" [isFooter]="true">
          <td *ngFor="let col of comexColumns" [ngStyle]="col.style">
            <div *ngIf="col.field === 'sequentialId'">
              <strong>Total</strong>
            </div>
            <div
              *ngIf="col.field === 'estimatedAmountBRL'"
              style="text-align: right; font-weight: bold; white-space: nowrap">
              {{ getComexTotalEstimatedBRL() | vaultFormatCurrency: 2 : 'BRL' }}
            </div>
          </td>
        </ng-template>
      </app-table>
    </div>

    <div
      class="no-data-info"
      *ngIf="!data.derivatives?.length && !data.loans?.length && !data.comex?.length">
      <app-simple-messages
        text="Nenhum dado encontrado para o período selecionado."
        severity="info">
      </app-simple-messages>
    </div>
  </div>

  <!-- Modals -->
  <app-modal-loan-details #loanDetailsModal></app-modal-loan-details>
  <app-modal-comex-operation-details #comexDetailsModal></app-modal-comex-operation-details>
</section>
